import { TableCell as MuiTableCell } from "@mui/material";
import { styled } from "@mui/material/styles";

export const TableCell = styled(MuiTableCell)(({ theme }) => ({
  padding: theme.spacing(1),
}));
